import {
  IAttachmentData,
  IRequisitionCommentData,
  IRequisitionData,
  IRequisitionLineData,
  IUserData,
  RequisitionFilterParams,
  RequisitionStatusEnum
} from '@/models';
import { Transition } from '@/models/transition';

export interface IRequisitionPaginatedListData {
  count: number;
  next?: string;
  previous?: string;
  results: IRequisitionData[];
}

export interface IRequisitionExportFilterParams
  extends RequisitionFilterParams {
  search?: string;
}

export interface IRequisitionFilterParam extends RequisitionFilterParams {
  page?: number;
  search?: string;
}

export interface IRequisitionService {
  fetchRequisitions(
    filter?: IRequisitionFilterParam
  ): Promise<IRequisitionPaginatedListData>;
  fetchRequisition(id: number): Promise<IRequisitionData>;
  createRequisition(data: IRequisitionData): Promise<IRequisitionData>;
  updateRequisition(data: IRequisitionData): Promise<IRequisitionData>;
  deleteRequisition(id: number): Promise<any>;
  updateRequisitionLine(
    requisitionId: number,
    data: IRequisitionLineData
  ): Promise<IRequisitionLineData>;
  deleteRequisitionAttachment(
    requisitionId: number,
    attachmentId: number
  ): Promise<any>;
  updateRequisitionState(
    id: number,
    state: RequisitionStatusEnum,
    assignee?: number,
    comment?: string
  ): Promise<IRequisitionData>;
  fetchRequisitionApprovers(id: number): Promise<IUserData[]>;
  fetchRequisitionBuyers(id: number): Promise<IUserData[]>;

  assignRequisitionBuyer(id: number, buyer: number): Promise<IRequisitionData>;

  updateRequisitionOwner(id: number, owner: number): Promise<IRequisitionData>;

  assignRequisitionPONumber(
    id: number,
    po_number: string
  ): Promise<IRequisitionData>;

  assignRequisitionApprover(
    id: number,
    approver: number
  ): Promise<IRequisitionData>;

  exportRequisitionHeader(id: number): Promise<void>;
  exportRequisitionLines(id: number, purchaseOrder: string): Promise<void>;
  fetchRequisitionActivities(id: number): Promise<Transition[]>;

  fetchRequisitionComments(requisitionId: number): Promise<IRequisitionData[]>;
  fetchRequisitionComment(
    requisitionId: number,
    commentId: number
  ): Promise<IRequisitionData>;
  createRequisitionComment(
    requisitionId: number,
    comment: IRequisitionCommentData
  ): Promise<IRequisitionData>;
  updateRequisitionComment(
    requisitionId: number,
    comment: IRequisitionCommentData
  ): Promise<IRequisitionData>;
  deleteRequisitionComment(
    requisitionId: number,
    commentId: number
  ): Promise<void>;

  addRequisitionCommentAttachments(
    requisitionId: number,
    commentId: number,
    attachments: IAttachmentData[]
  ): Promise<IRequisitionCommentData>;

  removeRequisitionCommentAttachment(
    requisitionId: number,
    commentId: number,
    attachmentId: number
  ): Promise<void>;

  //export requisition pdf
  exportRequisitionPdf(requisitionId: number): Promise<Blob>;

  exportRequisitions(params?: IRequisitionExportFilterParams): Promise<Blob>;

  updateMultipleRequisitionOwner(
    owner: number,
    requisitions: number[]
  ): Promise<void>;

  fetchRequisitionCommentsMentionableUsers(
    requisitionId: number
  ): Promise<IUserData[]>;
}

export const REQUISITION_EXPORT_TIMEOUT_IN_MILLISECONDS = 30 * 1000;
